import { type CSSProperties } from 'react';

import { getWorkspaceAgentPanelWidthCSSValue } from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentPanelWidthCSSValue';

export const WORKSPACE_AGENT_PANEL_UI2026_DOCKED_CARD_STYLE: CSSProperties = {
  height: '100%',
  maxWidth: getWorkspaceAgentPanelWidthCSSValue(),
  width: getWorkspaceAgentPanelWidthCSSValue(),
};
